import { Injectable } from '@angular/core';

@Injectable()
export class WikiAttachmentQueueService {
    private _pagename: string = '';
    private _files: File[] = [];

    get hasFiles(): boolean { return this._files.length > 0; }

    get displayItems(): any[] {
        return this._files.map(f => ({
            name: f.name, size: f.size, queued: true,
            percentComplete: 0, amountComplete: 0, amountTotal: f.size
        }));
    }

    stage(pagename: string, files: File[]): void {
        if (this._pagename !== pagename) {
            this._files = [];
            this._pagename = pagename;
        }
        this._files.push(...files);
    }

    remove(pagename: string, fileName: string): void {
        if (this._pagename !== pagename) { return; }
        this._files = this._files.filter(f => f.name !== fileName);
    }

    flush(pagename: string): File[] {
        if (this._pagename !== pagename) { return []; }
        const files = this._files.slice();
        this._files = [];
        this._pagename = '';
        return files;
    }

    isFor(pagename: string): boolean { return this._pagename === pagename; }
}
